import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import { Section } from 'common';
import strings from 'strings';
import { filterValidItems, isTruthyValue } from 'utils';

import { DescriptionText } from '../../styles';

export const Trainings = ({ trainings = [] }) => {
  const validTrainings = filterValidItems(trainings);
  if (validTrainings.length === 0) return null;

  return (
    <Section title={strings.candidates.profile.resumeTab.sections.trainingCoursesAndWorkshops}>
      <List disablePadding>
        {validTrainings.map(training => {
          const { description, year, issuing_organization: organization } = training;

          return (
            <ListItem key={organization} disableGutters>
              <ListItemText
                primary={
                  <>
                    {isTruthyValue(organization) && (
                      <Typography color="textSecondary">{organization}</Typography>
                    )}

                    {isTruthyValue(description) && (
                      <DescriptionText component="pre">
                        <b>{description}</b>
                      </DescriptionText>
                    )}

                    {isTruthyValue(year) && <Typography color="textSecondary">{year}</Typography>}
                  </>
                }
              />
            </ListItem>
          );
        })}
      </List>
    </Section>
  );
};
